import React, { useMemo } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { workspaceInitials } from '../../../../workspaces/workspaceInitials';
import styles from './ConnectedAppMark.module.scss';

const markHues = [styles.hue0, styles.hue1, styles.hue2, styles.hue3, styles.hue4, styles.hue5];

/** A stable number from the client id, so one app keeps its colour. */
function hueIndex(clientId: string): number {
  let sum = 0;
  for (let i = 0; i < clientId.length; i += 1) {
    sum += clientId.charCodeAt(i);
  }
  return sum % markHues.length;
}

interface ConnectedAppMarkProps {
  clientId: string;
  name: string;
}

/** design: connected-apps a1 .mark — the initials of the app on a gradient square. */
const ConnectedAppMarkComponent: React.FC<ConnectedAppMarkProps> = ({ clientId, name }) => {
  const hue = useMemo(() => markHues[hueIndex(clientId)], [clientId]);
  return (
    <span className={clsx(styles.mark, hue)} aria-hidden="true">
      {workspaceInitials(name)}
    </span>
  );
};

export const ConnectedAppMark = TypedMemo(ConnectedAppMarkComponent);
